import { useState, useEffect } from "react";
import IOnUpdateOrderEntryDetailDTO from "../../../models/DTO/IOnUpdateOrderEntryDetailDTO";
import EndpointsEnum from "../../../models/EndpointsEnum";
import IOrder from "../../../models/IOrder";
import IOrder_Item from "../../../models/IOrder_Item";
import EcommerceCartItem from "../EcommerceCartItem/EcommerceCartItem";
import "./EcommerceCartSidebar.scss";
import ISubmitOrderDTO from "../../../models/DTO/ISubmitOrderDTO";
import IUiSocketSetup from "../../../models/IUiSocketSetup";
import { ProcessOrderEntryItemFn } from "../../../models/OrderEntryTypes";
import { ConfirmDeleteOverlayFn } from "@components/shared/ConfirmDeleteOverlayFn/ConfirmDeleteOverlayFn";
import { useAppContextNonNull } from "@contexts/AppContext";

type Props = {
    order?: IOrder;
    cancelFn: (refreshData?: boolean) => void;
    deleteOrderEntryItem: (item: IOrder_Item) => void;
    updateOrderEntryItem: ProcessOrderEntryItemFn;
    toggleCheckoutView: () => void;
    isCheckoutView: boolean;
    submitOrder: (data: ISubmitOrderDTO) => void;
    shouldHidePricingFn: () => boolean;
    isReadOnly: boolean;
};

const EcommerceCartSidebar = (props: Props) => {
    const { userModel, supplierModel, uiContext, socket } = useAppContextNonNull();

    const [isActive, setIsActive] = useState(false);
    const [showConfirmDelete, setShowConfirmDelete] = useState(false);
    const [targetElem, setTargetElem] = useState<string | null>(null);
    const [selectedOrderItem, setSelectedOrderItem] = useState<IOrder_Item | null>(null);

    const onUpdateOrderEntryDetail = (data: IOnUpdateOrderEntryDetailDTO) => {
        setIsActive(false);
    };

    const sockets: IUiSocketSetup[] = [
        { endpoint: EndpointsEnum.OrderEntryOnUpdateOrderEntryDetail, fn: onUpdateOrderEntryDetail },
        // { endpoint: EndpointsEnum.OrderOnGetOrder, fn: onGetOrder },
    ];

    useEffect(() => {
        for (const _socket of sockets) {
            socket.on(_socket.endpoint, _socket.fn);
        }

        return () => {
            for (const _socket of sockets) {
                socket.off(_socket.endpoint, _socket.fn);
            }
        };
    }, []);

    const cancel = (refreshData?: boolean) => {
        props.cancelFn(refreshData);
    };

    const reviewAndSubmit = () => {
        props.toggleCheckoutView();
    };

    const preventScroll = (event: any) => {
        event.preventDefault();
        event.stopPropagation();
    };

    const toggleConfirmDelete = () => {
        setShowConfirmDelete(!showConfirmDelete);
    };

    const commitDelete = () => {
        if (selectedOrderItem) {
            props.deleteOrderEntryItem(selectedOrderItem);
            setShowConfirmDelete(false);
            setSelectedOrderItem(null);
        }
    };

    const selectElementToDelete = (row: IOrder_Item, index: number) => {
        setSelectedOrderItem(row);

        const elem = `order-item-row-${index}`;
        setTargetElem(elem);
        setShowConfirmDelete(true);
    };

    return (
        <div className={"EcommerceCartSidebar"}>
            <div id="cart-items" className={"cart-items p-2 position-relative"} onScroll={preventScroll} onScrollCapture={preventScroll}>
                {showConfirmDelete && (
                    <ConfirmDeleteOverlayFn
                        targetElem={targetElem}
                        handleConfirm={commitDelete}
                        handleCancel={toggleConfirmDelete}
                        nestedParentElem="cart-items"
                        skipMainView={true}
                        className="rounded"
                    />
                )}
                {!props.isCheckoutView &&
                    props.order &&
                    props.order.Order_Items.map((orderItem, index) => {
                        return (
                            <div key={orderItem.guid} className="mb-2">
                                <EcommerceCartItem
                                    order={props.order!}
                                    orderItem={orderItem}
                                    userModel={userModel}
                                    supplierModel={supplierModel}
                                    socket={socket}
                                    notifyFn={uiContext.notifyFn}
                                    selectElementToDelete={selectElementToDelete}
                                    updateOrderEntryItem={props.updateOrderEntryItem}
                                    isReadOnly={props.isReadOnly}
                                    isInSidebar={true}
                                    index={index}
                                />
                            </div>
                        );
                    })}
            </div>
        </div>
    );
};

export default EcommerceCartSidebar;
